import React from 'react';

//Componentes
import UserHomePage from './UserHomePage';

function UserHomePageContainer() {
    return <UserHomePage />;
}

export default UserHomePageContainer;
